<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" ref="layout" fullscreen hide-overlay transition="dialog-bottom-transition">
      
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dismiss();">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{translater.__('More than one route have the same focus point, please select one', 'routes')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            
          </v-toolbar-items>
        </v-toolbar>

        <v-text-field
		        v-model="search"
		        append-icon="search"
		        :label="this.$store.getters['translate/translater'].__('Search')"
		        single-line
		        hide-details
	      ></v-text-field>
	      <v-data-table
				:headers="headers"
				:items="items"
				:loading="false"
				:search="search"
				class="elevation-1"
				:rows-per-page-text="translater.__('rows per page', 'dt')"
				:rows-per-page-items="[5,10,15,25, {text: translater.__('All', 'dt'), value:-1}]"
				
			>
			<template slot="pageText" scope="{ pageStart, pageStop }">
			    {{
			    	translater.__("rows {0} - {1}", 'dt', pageStart, pageStop)
			    }}
			</template>
			<template slot="no-data">
				{{
					this.$store.getters["translate/translater"].__("Nothing to show")
				}}
			</template>
		    <template slot="items" slot-scope="props">
		      <tr id="props.item.id" @click="setRoute(props.item)">
		      	  	
			      <td class="text-xs-left">
			      	{{props.item.displayName}}
			      </td>
			      
			  </tr>
			  

		      
		    </template>
		</v-data-table>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
	import {translater} from '../../tools/translate';
	import {setRoute} from '../../tools/';
	export default {
		name: 'MatchingFocusPoints',
		data() {
			return {
				notifications:  [],
				sound: undefined,
				widgets: [],
				headers: [
					
					{
						text: translater.__("Route", "routes"),
						value: 'displayName'
					}
				],
				
			}
		},
		
		
		created()
		{

		},

		mounted()
		{
			/* this is here, 'cause there's no way to set new z-index value the "vue way" and the default z-index is wrong and thus the dialog gets left behind the map */
			document.getElementsByClassName('v-dialog__content')[0].style.zIndex = 3000;
		
			
		},

		methods: {

			

			dismiss()
			{
				window.vm.$emit('showPrevMarker');
				//window.vm.$emit('hideLocations', 'locations')
				this.$store.dispatch('locations/setShowSelectedLocationDialog', false)
				this.dialog = !this.dialog;
			},

			setRoute(route)
			{

				setRoute(route, this.$store)		
				/*this.$store.dispatch('locations/features', route._id)
				.then((res) => {
					let features = {};
					let rotation = 0;
					let key = "";
					let keys = [];
					res.data.forEach((f) => {
						key = f.geometry.coordinates[1] + "-" + f.geometry.coordinates[0];
						if(
							!keys.find((k) => {
								return key == k
							})
						) {
							keys.push(key);
							features[key] = [];
						}
						
						rotation = features[key].length * 60;
						features[key].push(
							{rotation: rotation, location: f, draggable: false}
						);

						
					});


					

					this.$store.commit('locations/features', features);
					this.$store.dispatch('routes/setPreviousVisible', undefined, {root: true});

					this.$store.dispatch('routes/setVisible', false, {root: true});

					this.$store.dispatch('lines/lines', route, {root:true})
					.then((res) => {
						this.$store.commit('lines/lines', res.data)
						window.vm.$emit('features', features)
					})
					.catch((err) => {
						window.vm.$emit('features', features)
						console.log(err);
					})



					


				})
				.catch((err) => {
					console.log(err);
				}) */

				/*this.$store.dispatch('locations/setLocationLayerGroupVisible', true);
				//this.$store.dispatch('routes/setRouteLayerGroupVisible', false) */
				//window.vm.$emit('setRoute', route);

				this.dialog = false;
			}

			
		},

		computed: {
			dialog: {
				get: function()
				{
					return this.$store.getters['routes/showMatchingFocusPointsDialog'];
				},

				set: function(value)
				{
					this.$store.dispatch('routes/setShowMatchingFocusPointsDialog', value);
				}
			},

			translater: {
				get: function()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			search: {
				get: function()
				{
					return this.$store.getters['routes/search'];
				},

				set: function(value)
				{
					this.$store.dispatch('routes/setSearch', value);
				}
			},

			items: {
				get()
				{
					return this.$store.getters['routes/matchingFocusPoints'][this.$store.getters['routes/selectedMarker']._id]
				}
			}




		}

		
	}
</script>


